export const PERMISSIONS = {
    DOOTAX: {
        NFE: {
            DASHBOARD: "dootax-nfe-dashboard",
            GERENCIAR: {
                VISUALIZAR: "dootax-nfe-visualizar",
                CANCELAR: "dootax-nfe-cancelar",
                EMITIR_CARTA_CORRECAO: "dootax-nfe-emitir-carta-correcao"
            },
            INUTILIZAR_NUMERACAO: {
                VISUALIZAR: "dootax-nfe-inutilizar-numeracao-visualizar",
                INUTILIZAR: "dootax-nfe-inutilizar-numeracao-inutilizar"
            },
            CONFIGURACAO: {
                VISUALIZAR: "dootax-nfe-config-visualizar",
                EDITAR: "dootax-nfe-config-editar"
            }
        },
		NFCE: {
            DASHBOARD: "dootax-nfce-dashboard",
            GERENCIAR: {
                VISUALIZAR: "dootax-nfce-visualizar",
                CANCELAR: "dootax-nfce-cancelar"
            },
            INUTILIZAR_NUMERACAO: {
                VISUALIZAR: "dootax-nfce-inutilizar-numeracao-visualizar",
                INUTILIZAR: "dootax-nfce-inutilizar-numeracao-inutilizar"
            },
            CONFIGURACAO: {
                VISUALIZAR: "dootax-nfce-config-visualizar",
                EDITAR: "dootax-nfce-config-editar"
            }
        },
        CTE: {
            DASHBOARD: "dootax-cte-dashboard",
            GERENCIAR: {
                VISUALIZAR: "dootax-cte-visualizar",
                CANCELAR: "dootax-cte-cancelar",
                EMITIR_CARTA_CORRECAO: "dootax-cte-emitir-carta-correcao"
            },
            CONFIGURACAO: {
                VISUALIZAR: "dootax-cte-config-visualizar",
                EDITAR: "dootax-cte-config-editar"
            }
        },
        /* o MDF-e nao tem carta de correcao: no lugar dela, o encerramento */
        MDFE: {
            DASHBOARD: "dootax-mdfe-dashboard",
            GERENCIAR: {
                VISUALIZAR: "dootax-mdfe-visualizar",
                CANCELAR: "dootax-mdfe-cancelar",
                ENCERRAR: "dootax-mdfe-encerrar"
            },
            CONFIGURACAO: {
                VISUALIZAR: "dootax-mdfe-config-visualizar",
                EDITAR: "dootax-mdfe-config-editar"
            }
        }
    }
}